import { Button } from "@/core/components/ui/button";
import { Card } from "@/core/components/ui/card";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useReportRun } from "@/profitability/query";
import { reportError } from "@/profitability/utils";
import { BackToReports } from "./back-to-reports";
import { LoadedReport } from "./loaded-report";
export const RunDetail = ({
  businessId,
  runId,
}: {
  businessId: string;
  runId: string;
}) => {
  const query = useReportRun(businessId, runId);

  if (query.isPending)
    return (
      <>
        <Stack gap="sm" className="flex-none py-4" fullWidth>
          <BackToReports />
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </Stack>
        <Card className="min-h-0 w-full flex-1 border-stroke-tertiary shadow-none" />
      </>
    );

  // Only when there is nothing to show: a report polls every two seconds while
  // it builds, and one failed poll must not replace it with an error page.
  if (query.error && !query.data)
    return (
      <Stack gap="md" className="flex-none py-4" fullWidth align="start">
        <BackToReports />
        <Typography variant="subtitleW3">
          This report could not be loaded
        </Typography>
        <Typography variant="bodyW3" textColor="secondary">
          {reportError(query.error)}
        </Typography>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => void query.refetch()}
        >
          Try again
        </Button>
      </Stack>
    );

  return (
    <LoadedReport
      key={`${businessId}:${query.data.id}`}
      businessId={businessId}
      run={query.data}
    />
  );
};
